import React from 'react';

import Border from '../border';
import AddNode from './treeAddNodes';
import TreeLeaf from '../draggableTreeLeaf';

const Content = ({
  nodes = [],
  isExpand,
  onAddNode,
  hasAddNode,
  containerId,
  ...rest
}) => (
  // console.log('[_nodes] - ', nodes)
  <div className={`lifecycle-content-wrapper ${isExpand ? '' : 'closed'}`}>
    <Border />
    {nodes.length > 0 && <div className="blank-block" />}
    {nodes.map((node, index) => (
      <TreeLeaf
        {...rest}
        index={index}
        collection={containerId}
        key={node.key || node.id || `new-node-${index}`}
        data={node}
        leafOrder={node.order} //location in data collection
        containerId={containerId}
      />
    ))}

    {hasAddNode && <AddNode onAddNode={onAddNode} />}
  </div>
);
export default Content;
